"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-bianco": {
    "402e048d": [{
      "hkey": "6b75c861",
      "slug": "costa-san-gallo-santuario",
      "name": "Costa San Gallo-Santuario",
      "primary": true,
      "skipSearch": false
    }],
    "costa-san-gallo": [{
      "hkey": "6b75c861",
      "slug": "costa-san-gallo-santuario",
      "name": "Costa San Gallo-Santuario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54608689": [{
      "hkey": "750cecef",
      "slug": "roncaglia-entro",
      "name": "Roncaglia Entro",
      "primary": true,
      "skipSearch": false
    }],
    "roncaglia": [{
      "hkey": "750cecef",
      "slug": "roncaglia-entro",
      "name": "Roncaglia Entro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;